
import React, { useState, useEffect, useImperativeHandle, forwardRef } from 'react';
import Preloader from '../../../general/Preloader';
import ModalIndex from './password_new/ModalIndex';

const FormLogin = forwardRef((props, ref) => {
    const token = document.querySelector("[name='csrf-token']").content;
    const [showErrorMessaje, setShowErrorMessaje] = useState(false);
    const [modalIndex, setModalIndex] = useState(false);
    const [errorValues, setErrorValues] = useState(true);
    const [isLoaded, setIsLoaded] = useState(false);
    const [form, setForm] = useState({ 
        email: "", 
        password: "",
        discount_code_id: props.discount.id,
        price_id: props.price.id,
        reference_id: props.reference
    });

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value })
    }

    const handleChangeEmail = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value.toLowerCase() })
    }

    const handleSubmit = e => {
        e.preventDefault();
    };

    const toogleModalIndex = () => {
        setModalIndex(!modalIndex)
    }

    const clearValues = () => {
        setIsLoaded(false);
        setForm({ 
            email: "", 
            password: "",
            discount_code_id: props.discount.id,
            price_id: props.price.id,
            reference_id: props.reference
        })
    }

    const validationForm = () => {
        if (form.email != "" &&
            form.password != "" 
        ) {
            setErrorValues(true)
            return true
        }else{
            setErrorValues(false)
            return false
        }
    }

    const handleClick = () => {
        if(validationForm()){
            setIsLoaded(true);

            fetch(`/api/v1/validate_credentials`, {
                method: 'POST', // or 'PUT'
                body: JSON.stringify(form), // data can be `string` or {object}!
                headers: {
                    "X-CSRF-Token": token,
                    "authorization": "98a2425c7cd22d4dad50",
                    "Content-Type": "application/json"
                }
            })
    
            .then(res => res.json())
            .catch(error => console.error("Error:", error))
            .then(data => {
                console.log("data", data);
                
                if(data.valid){ 
                    setShowErrorMessaje(false);
                    props.setUserState(data.register);
                    props.tooglePasstab("payment");
                    clearValues();
                }else{
                    setShowErrorMessaje(true)
                    clearValues();
                }
            });
        }
    }

    return (
        <React.Fragment>
            {modalIndex && (
                <ModalIndex
                    //modal props
                    backdrop={"static"}
                    modal={modalIndex}
                    toggle={toogleModalIndex}
                />
            )}

            <form onSubmit={handleSubmit}>                 
                <div className="card mt-3">
                    <div className="card-body form-login pb-2">  
                        {!isLoaded ? (
                            <React.Fragment>
                                <div className="row">
                                    <div className="col-md-12 text-left mb-3">
                                        <div className="title-user-form">
                                            <h4 className='mb-0 text-white'>Ingreso</h4>
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <label className='text-primary'>Email <span className='error-label'>*</span></label>
                                        <input 
                                            type="email"
                                            className={`form form-control ${!errorValues && form.email == "" ? "error-class" : ""}`}
                                            name='email'
                                            value={form.email}
                                            onChange={handleChangeEmail}
                                        />
                                    </div> 

                                    <div className="col-md-6">
                                        <label className='text-primary'>Contraseña <span className='error-label'>*</span></label>
                                        <input 
                                            type="password" 
                                            autoComplete='off'
                                            className={`form form-control ${!errorValues && form.password == "" ? "error-class" : ""}`}
                                            name='password'
                                            value={form.password}
                                            onChange={handleChange}
                                        />
                                    </div> 

                                    <div className="col-md-12 mt-2">
                                        <a 
                                            href="javascript:void(0)"
                                            className='text-primary'
                                            onClick={() => toogleModalIndex()}
                                        >
                                            ¿Olvidaste tu contraseña?
                                        </a>
                                    </div>

                                    {showErrorMessaje && (
                                        <div className="col-md-12 mt-3">
                                            <div className="alert alert-danger text-center text-white" role="alert">
                                                El correo electrónico o la contraseña ingresados son inválidos. Por favor, verifica tus datos e intenta nuevamente.
                                            </div>
                                        </div>    
                                    )}
                                </div>
                            </React.Fragment>
                        ) : (
                            <div className="text-center">
                                <Preloader/>
                            </div>
                        )}
                    </div>

                    {!errorValues && (
                        <div className="col-md-12 mt-4">
                            <div className="alert alert-danger text-center text-white" role="alert">
                                <b className='text-white'>Debes de completar todos los campos requeridos</b>
                            </div>
                        </div>
                    )}

                    {!isLoaded && (
                        <div className="card-footer">
                            <button className='btn btn-primary' disabled={isLoaded} onClick={() => handleClick()}>{isLoaded ? "Cargando..." : "Siguiente"}</button>
                            <button className='btn btn-light ml-2' onClick={() => props.toogleTab("user_form")}>Volver</button>
                        </div>
                    )}
                </div>     
            </form>
        </React.Fragment>
    );
});


export default FormLogin;
